export const REPLY_RECOMMENDATION_RECEIVED = 'REPLY_RECOMMENDATION_RECEIVED';